import { createFeatureSelector } from "@ngrx/store";

export const USER_STATE_FEATURE = "user";

export const selectUserState = createFeatureSelector(USER_STATE_FEATURE);
